module.exports = __webpack_public_path__ + "static/P2101553-84c7cf499af9ee721011594260cee414.jpg";